import WineBar from "../../assets/images/food-and-drink/wine-bar/wine_bar1.jpg";
// import TheCommons from "../../assets/images/live-local/the-commons.jpg";
import lobby_image_1 from "../../assets/images/food-and-drink/lobby_second_image.jpg";
import AuntLucys from "../../assets/images/live-local/aunt-lucys.jpg";
import TheAnnexCafe from "../../assets/images/food-and-drink/cafe_1.jpg";

import Boombox from "../../assets/images/experience/boombox.png";
import Confetti from "../../assets/images/experience/confetti.png";
import RedVista from "../../assets/images/experience/red-vista.png";
import NeonHallway from "../../assets/images/experience/neon-hallway.png";

export const discoverCardCarouselData = [
  {
    imageSrc: WineBar,
    imageAlt: "Raffaella",
    imageTitle: "Raffaella",
    title: "Raffaella",
    paragraph:
      "Raffaella, in The Annex Hotel, was founded by Simon Vickerson to honor his grandmother, Raffaella. The menu offers nostalgic Italian dishes inspired by her comforting, homey recipes.",
    linkTo: "/eat-and-drink#wine-bar",
    hash: true,
  },
  {
    imageSrc: TheAnnexCafe,
    imageAlt: "Annex Cafe",
    imageTitle: "Annex Cafe",
    title: "Annex Cafe",
    paragraph:
      "The Annex Cafe offers a rotating selection of drinks and food, featuring coffee from The Angry Roaster and pastries from Petite Thuet. Located in our Lobby, it's the perfect spot to work, catch up with a friend, or grab coffee to go.",
    linkTo: "/eat-and-drink#cafe",
    hash: true,
  },
  {
    imageSrc: lobby_image_1,
    imageAlt: "Lobby",
    imageTitle: "Lobby",
    title: "Lobby",
    paragraph:
      "The heartbeat of the hotel, our cafe transitions from morning coffee to 5 o’clock martinis. With inspiring art, a curated wine list, and snacks from Raffaella, it’s perfect for conversation or taking home a memory.",
    linkTo: "/events",
    buttonText: "Discover",
    hash: true,
  },
  // {
  //   imageSrc: AuntLucys,
  //   imageAlt: "Aunt Lucy’s",
  //   imageTitle: "Aunt Lucy’s",
  //   title: "Aunt Lucy’s",
  //   paragraph:
  //     "Ghanian inspired smashburgers, chicken sandwiches and more. Named after the founder’s grandmother, Aunty Lucy’s is the ideal late night meal. Pairs well with wine and good times.",
  //   linkTo: "/eat-and-drink#aunty-lucys",
  //   url: "",
  //   hash: true,
  // },
];

export const musicCarouselData = [
  {
    imageSrc: Boombox,
    imageAlt: "Boombox",
    imageTitle: "Boombox",
    title: "Featured Favs",
    paragraph: "Our favourite home grown artists…",
    linkTo: "#",
    url: "https://open.spotify.com/album/6W4MCaXvhyiD2n26kv4e2R",
    hash: false,
  },
  {
    imageSrc: Confetti,
    imageAlt: "Confetti",
    imageTitle: "Confetti",
    title: "Party Hits",
    paragraph:
      "Our biggest mix of pop and dance hits to get you in the groove…",
    linkTo: "#",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXa2PvUpywmrr",
    hash: false,
  },
  {
    imageSrc: RedVista,
    imageAlt: "Red Vista",
    imageTitle: "Red Vista",
    title: "lofi beats",
    paragraph: "Beats to relax, study, and focus…",
    linkTo: "#",
    url: "https://open.spotify.com/playlist/37i9dQZF1DWWQRwui0ExPn",
    buttonText: "",
    hash: false,
  },
  {
    imageSrc: NeonHallway,
    imageAlt: "Neon Hallway",
    imageTitle: "Neon Hallway",
    title: "Playlist Name",
    paragraph: "I can’t think of anything else to put for a fake playlist…",
    linkTo: "#",
    url: "https://open.spotify.com/playlist/37i9dQZF1DWXRqgorJj26U",
    hash: false,
  },
];
